import { TitleCasePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { OneIncInitResponse } from './OneIncInitResponse';
import { PaymentServiceService } from '../payment-service/payment-service.service';

@Injectable({
  providedIn: 'root'
})
export class BillingNewService {
  isOneIncPayment = new BehaviorSubject<boolean>(false);
  hideBannerSubject = new BehaviorSubject<boolean>(false);
  private checkingOrSavingsSelectedSubject = new BehaviorSubject<boolean>(false);  

  hideBanner$ = this.hideBannerSubject.asObservable();
  checkingOrSavingsSelected$ = this.checkingOrSavingsSelectedSubject.asObservable();

  constructor(
    private titleCasePipe: TitleCasePipe,
    private http: HttpClient,
    private paymentService: PaymentServiceService
  ) { }

  setBannerState(value: boolean){
    this.hideBannerSubject.next(value);
  }

  getOneIncPaymentStatus() {
    return this.isOneIncPayment.asObservable();
  }
  setOneIncPaymentStatus(value: boolean) {
    this.isOneIncPayment.next(value);
  }

  setCheckingOrSavingsSelected(value: boolean): void {
    this.checkingOrSavingsSelectedSubject.next(value);
  }
  getCompany(policies): string {
    let company = 'Guidewire';
    // let company = 'TW';
    policies.filter(policy => {
      if (policy.company?.companyName == 'TW') {
        company = 'TW'
      } else if (policy.company?.companyName == 'ACIC') {
        company = 'V12'
      } else if (policy.policynumber?.policyNumber?.length == 6) {
        company = 'AS400'
      }
    })
    return company;
  }

  getActiveInActivePoliciesMap(policies, selectRequired?) {
    const activePolicies = policies.filter(pol => pol.policyStatus === 'ACTIVE' || pol.policyStatus === 'FUTURE');
    const inActivePolicies = policies.filter(pol => !(pol.policyStatus === 'ACTIVE' || pol.policyStatus === 'FUTURE'));

    const activePolicyMap = activePolicies.map(p => {
      const modifiedPolicyName = ((p.policyType === 'HOME') ? "Property" : this.titleCasePipe.transform(p.policyType));
      return { ...p, disabled: false, name: `${modifiedPolicyName} - ${p.policynumber.policyNumber}` }
    });

    const inActivePolicyMap = inActivePolicies.map(p => {
      const modifiedPolicyName = ((p.policyType === 'HOME') ? "Property" : this.titleCasePipe.transform(p.policyType));
      return { ...p, disabled: false, name: `${modifiedPolicyName} - ${p.policynumber.policyNumber}` }
    });

    if ((policies?.length > 1 || activePolicies?.length > 1) && selectRequired) {
      activePolicyMap.unshift({ name: 'Select one' });
    }

    if ((policies?.length > 1 || inActivePolicies?.length > 1) && selectRequired) {
      inActivePolicyMap.unshift({ name: 'Select one' });
    }

    // if(activePolicyMap?.length === 1 ) {
    //   inActivePolicyMap[0] = {name: 'Select one', disabled: true};
    // }
    // if(inActivePolicyMap?.length === 1 ) {
    //   activePolicyMap[0] = {name: 'Select one', disabled: true};
    // }

    return { activePolicies, activePolicyMap, inActivePolicies, inActivePolicyMap }
  }

  
  getCustomerId(email: string) {
    return this.http.get(`${environment.backend_server_url_account}/getOncIncCustomerId/${email}`, { responseType: 'text' });
  }

  getOneIncTokens(payload: any): Observable<OneIncInitResponse> {
    return this.http.post<OneIncInitResponse>(
      `${environment.backend_server_url_billing}/getOncIncTokens`,
      payload
    );
  }

  getOneIncTokensForGuest(payload: any): Observable<OneIncInitResponse> {
    return this.http.post<OneIncInitResponse>(
      `${environment.backend_server_url_billing}/guest/getOncIncTokens`,
      payload
    );
  }

  getV2OneIncTokensForGuest(payload: any): Observable<OneIncInitResponse> {
      return this.http.post<OneIncInitResponse>(
      // `/b2c-billing/v1/v2/guest/getOncIncTokens`,
      `${environment.backend_server_url_billing}/v2/guest/getOncIncTokens`,
      payload,
      { headers: this.getGuestSessionHeaders() }
    );
  }

  validateZipForOneInc(zipcode: string, policyNumber: string): Observable<{ message: string; state: string }> {
    return this.http.post<{ message: string; state: string }>(
      `${environment.backend_server_url_billing}/guest/oneinc/${zipcode}/${policyNumber}/validateZipcode`,
      {}
    );
  }

  private getGuestSessionHeaders(): HttpHeaders {
    const sessionToken = this.paymentService.getGuestSessionToken();
    return new HttpHeaders(
      sessionToken ? { 'X-Guest-Session': sessionToken } : {}
    );
  }

  getPaymentNotificationDetails(): Observable<any>{
    return this.http.get(
      `${environment.backend_server_url_account}/guest/get-generic-banner/oneIncBanner`
    );
  }

  postPaymentEvent(payload: string): Observable<any> {
    return this.http.post(
      `${environment.backend_server_url_billing}/logOneIncUserAction`,
      payload,
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

  postPaymentEventGuest(payload: string): Observable<any> {
    return this.http.post(
      `${environment.backend_server_url_billing}/guest/logOneIncUserAction`,
      payload,
      { headers: { 'Content-Type': 'application/json' } }
    );
  }

}

